<template>
  <Form v-if="load" :associate="associate"/>
</template>

<script>
  import Form from '@/components/admin/associates/Form'
  import ModelMapper from '@/mixins/ModelMapper'
  import { mapMutations } from 'vuex'

  export default {
    components: { Form },
    created() {
      this.asyncTemplateShow(this.id, {
        after: ({model}) => {
          this.associate = model
          this.setNameBreadcrumb(model.name)
          this.load = true
        }
      })
    },
    data() {
      return {
        associate: {},
        load: false,
        modelPathPrefix: 'admin',
        nameModel: 'Associate'
      }
    },
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
    },
    mixins: [ModelMapper],
    name: 'Show',
    props: ['id']
  }
</script>

<style scoped>

</style>